(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["review-feedback-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-review-feedback]');
    if (!root) return;

    const screens = Array.from(root.querySelectorAll('[data-screen]'));
    const ratingButtons = Array.from(root.querySelectorAll('[data-rating]'));
    const selectedRatingInputs = Array.from(root.querySelectorAll('[data-selected-rating]'));
    const selectedStars = root.querySelector('[data-selected-stars]');
    const supportStars = root.querySelector('[data-support-stars]');
    let selectedRating = 0;

    const track = (eventName, detail = {}) => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: eventName, ...detail });
    };

    const renderStars = (target) => {
      if (!target) return;
      target.textContent = '★'.repeat(selectedRating) + '☆'.repeat(5 - selectedRating);
    };

    const showScreen = (name) => {
      screens.forEach((screen) => {
        const active = screen.dataset.screen === name;
        screen.hidden = !active;
        screen.classList.toggle('is-active', active);
        if (active) screen.querySelector('[data-screen-heading]')?.focus({ preventScroll: true });
      });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const highlightStars = (rating) => {
      ratingButtons.forEach((button) => {
        button.classList.toggle('is-highlighted', Number(button.dataset.rating) <= rating);
      });
    };

    ratingButtons.forEach((button) => {
      button.addEventListener('mouseenter', () => highlightStars(Number(button.dataset.rating)));
      button.addEventListener('focus', () => highlightStars(Number(button.dataset.rating)));
      button.addEventListener('click', () => {
        selectedRating = Number(button.dataset.rating);
        selectedRatingInputs.forEach((input) => { input.value = String(selectedRating); });
        ratingButtons.forEach((item) => item.setAttribute('aria-checked', String(item === button)));
        renderStars(selectedStars);
        renderStars(supportStars);
        track('feedback_rating_selected', { rating: selectedRating });
        showScreen('share');
      });
    });

    root.querySelector('[data-screen="rating"]')?.addEventListener('mouseleave', () => highlightStars(selectedRating));
    root.querySelector('[data-open-support]')?.addEventListener('click', () => {
      track('feedback_support_opened', { rating: selectedRating });
      showScreen('support');
    });
    root.querySelector('[data-back-to-rating]')?.addEventListener('click', () => showScreen('rating'));
    root.querySelector('[data-back-to-share]')?.addEventListener('click', () => showScreen('share'));
    root.querySelectorAll('[data-trustpilot-link]').forEach((link) => {
      link.addEventListener('click', () => track('feedback_trustpilot_clicked', { rating: selectedRating }));
    });
    root.querySelector('#willow-feedback-form')?.addEventListener('submit', () => {
      track('feedback_support_submitted', { rating: selectedRating });
    });

    if (new URLSearchParams(window.location.search).get('contact_posted') === 'true') {
      showScreen('support');
    }

    track('feedback_page_viewed');
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["willow-morning-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('willow-morning-hero')) {
    customElements.define('willow-morning-hero', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.toggle = this.querySelector('.willow-morning__toggle');
        if (!this.video || !this.toggle) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.wantsPlayback = !this.motion.matches && !navigator.connection?.saveData;
        this.inView = true;
        this.pending = false;
        this.video.muted = true;
        this.video.defaultMuted = true;
        this.video.playsInline = true;
        this.toggle.hidden = false;
        const update = () => {
          const playing = !this.video.paused;
          this.toggleAttribute('data-playing', playing);
          this.toggle.setAttribute('aria-label', playing ? this.toggle.dataset.pauseLabel : this.toggle.dataset.playLabel);
        };
        this.toggle.addEventListener('click', () => {
          this.wantsPlayback = this.video.paused;
          this.syncPlayback();
        }, options);
        this.video.addEventListener('playing', () => {
          this.setAttribute('data-ready', '');
          update();
        }, options);
        this.video.addEventListener('pause', update, options);
        this.video.addEventListener('error', () => {
          this.removeAttribute('data-ready');
          this.wantsPlayback = false;
          update();
        }, options);
        document.addEventListener('visibilitychange', () => this.syncPlayback(), options);
        window.addEventListener('pageshow', () => this.syncPlayback(), options);
        this.motion.addEventListener('change', () => {
          if (this.motion.matches) {
            this.wantsPlayback = false;
            this.syncPlayback();
          }
        }, options);
        this.observer = new IntersectionObserver(([entry]) => {
          this.inView = entry.isIntersecting;
          this.syncPlayback();
        }, { threshold: .05 });
        this.observer.observe(this);
        this.syncPlayback();
      }
      syncPlayback() {
        if (!this.isConnected) return;
        if (!this.wantsPlayback || !this.inView || document.hidden) {
          this.video.pause();
          return;
        }
        if (this.pending || !this.video.paused) return;
        if (!this.video.getAttribute('src')) {
          this.video.src = matchMedia('(max-width: 749px)').matches ? this.video.dataset.mobileSrc : this.video.dataset.desktopSrc;
          this.video.preload = 'auto';
        }
        this.video.muted = true;
        this.pending = true;
        this.video.play().catch(() => {
          this.wantsPlayback = false;
          this.toggleAttribute('data-playing', false);
          this.toggle.setAttribute('aria-label', this.toggle.dataset.playLabel);
        }).finally(() => { this.pending = false; });
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.video?.pause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
